import {Row, Col} from 'react-bootstrap'
import {useState} from 'react'
import './TimePicker.css'
import {TIMEOPTIONS, WEEKDAYS} from './GetReportUtils'
type ScheduleProps = {
  scheduleType: string
  setScheduleType: any
  selectedDay: string
  setSelectedDay: any
  selectedDate: string
  setSelectedDate: any
  selectedTime: any
  setSelectedTime: any
}

export default function ScheduleRecurring({
  scheduleType,
  setScheduleType,
  selectedDay,
  setSelectedDay,
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
}: ScheduleProps) {
  const date: any = () => {
    const temp = []
    for (let i = 1; i < 32; i++) {
      temp.push(i)
    }
    return temp
  }
  const [dates] = useState(date())

  return (
    <div>
      <h4 className='fs-3 text-gray-800 fw-bolder'>Schedule Recurring</h4>
      <p className='text-gray-500 fs-7 fw-semibold'>All reports will be in Eastern Time (ET)</p>
      <Row className='d-flex align-items-end mt-5 no-gutters noPadding mb-5 '>
        <Col sm md lg={6}>
          <label className='d-flex align-items-center mb-2'>
            <span className='fs-6 fw-semibold lh-23'>Recurring Type</span>
          </label>
          <select
            id='Voice'
            aria-label='select brand'
            className='form-select form-select-solid'
            value={scheduleType}
            onChange={(e) => setScheduleType(e.target.value)}
          >
            <option value='DAILY'>Daily</option>
            <option value='MONTHLY'>Monthly</option>
            <option value='WEEKLY'>Weekly</option>
          </select>
        </Col>
        <Col sm md lg={6}>
          <label className='d-flex align-items-center mb-2'>
            <span className='fs-6 fw-semibold lh-23'>Time</span>
          </label>

          <select
            id='time'
            aria-label='select time'
            className='form-select form-select-solid'
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
          >
            {TIMEOPTIONS.map((option: any) => (
              <option value={option}>{option}</option>
            ))}
          </select>
        </Col>
      </Row>
      {scheduleType === 'WEEKLY' && (
        <ul className='nav nav-stretch nav-pills nav-pills-custom nav-pills-active-custom d-flex justify-content-between mb-8 px-5'>
          {WEEKDAYS.map((week: any) => (
            <li key={week.enum} className='nav-item p-0 ms-0' role='presentation'>
              <button
                className={`btn d-flex flex-column flex-center rounded-pill min-w-45px py-4 px-3 btn-active-primary ${
                  selectedDay === week.enum && 'active'
                }`}
                onClick={() => setSelectedDay(week.enum)}
              >
                <div className='fs-7 fw-semibold my-2'>{week.day}</div>
              </button>
            </li>
          ))}
        </ul>
      )}
      {scheduleType === 'MONTHLY' && (
        <ul className='nav nav-stretch nav-pills nav-pills-custom nav-pills-active-custom d-flex justify-content-between mb-8 px-5'>
          {dates.map((week: any) => (
            <li key={week.enum} className='nav-item p-0 ms-0' role='presentation'>
              <button
                className={`btn d-flex flex-column flex-center rounded-pill min-w-45px py-4 px-3 btn-active-primary ${
                  selectedDate === String(week) && 'active'
                }`}
                onClick={() => setSelectedDate(String(week))}
              >
                <div className='fs-7 fw-semibold my-2'>{week}</div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
